import {
	createStyles,
	makeStyles,
} from '@mui/styles';
import {
	alpha,
	darken,
	Theme,
} from '@mui/material/styles';

const useStyles = makeStyles((theme: Theme) => {
	return createStyles({
		checkBoxIconInput_bodyInteriorContainer: {
			display: 'flex',
			width: '100%',
		},
		inputCheckboxIcon_iconWrapper: {
			padding: '5px',
			display: 'flex',
			flexDirection: 'column',
			justifyContent: 'center',
			borderRadius: `${theme.shape.borderRadius}px 0px 0px ${theme.shape.borderRadius}px`,
		},
		inputCheckboxIcon_iconWrapperSelect: {
			background: theme.palette.primary.main,
			borderLeft: `solid 2px ${theme.palette.primary.main}`,
			borderTop: `solid 2px ${theme.palette.primary.main}`,
			borderBottom: `solid 2px ${theme.palette.primary.main}`,
		},
		inputCheckboxIcon_iconWrapperUnselect: {
			background: darken(theme.palette.grey[500], .15),
			borderLeft: `solid 2px ${darken(theme.palette.grey[500], .15)}`,
			borderTop: `solid 2px ${darken(theme.palette.grey[500], .15)}`,
			borderBottom: `solid 2px ${darken(theme.palette.grey[500], .15)}`,
		},
		inputCheckboxIcon_iconWrapperDisable: {
			background: theme.palette.grey[300],
			borderLeft: `solid 2px ${theme.palette.grey[300]}`,
			borderTop: `solid 2px ${theme.palette.grey[300]}`,
			borderBottom: `solid 2px ${theme.palette.grey[300]}`,
		},
		inputCheckboxIcon_iconWrapperSelectDisable: {
			background: theme.palette.primary[300],
			borderLeft: `solid 2px ${theme.palette.primary[300]}`,
			borderTop: `solid 2px ${theme.palette.primary[300]}`,
			borderBottom: `solid 2px ${theme.palette.primary[300]}`,
		},
		inputCheckboxIcon_icon: {
			color: theme.palette.common.white,
		},
		inputCheckboxIcon_bodyFullWidth: {
			width: '100%',
		},
		inputCheckboxIcon_body: {
			display: 'flex',
			flexDirection: 'row',
			borderRadius: theme.shape.borderRadius,
		},
		inputCheckboxIcon_bodyUnselect: {

		},
		inputCheckboxIcon_bodySelect: {

		},
		inputCheckboxIcon_bodyDisable: {

		},
		inputCheckboxIcon_bodySelectDisable: {

		},
		inputCheckboxIcon_bodyFocusUnselect: {
			transition: `box-shadow ${theme.transitions.duration.standard}ms ${theme.transitions.easing.easeInOut}`,
			boxShadow: `0px 0px 0px -1px ${alpha(theme.palette.common.black, .2)}, 0px 2px 4px 0px ${alpha(theme.palette.common.black, .08)}, 0px 1px 5px 0px ${alpha(theme.palette.common.black, .38)}`,
		},
		inputCheckboxIcon_bodyFocusSelect: {
			transition: `box-shadow ${theme.transitions.duration.standard}ms ${theme.transitions.easing.easeInOut}`,
			boxShadow: `0px 0px 0px -1px ${alpha(theme.palette.primary.main, .4)}, 0px 2px 4px 0px ${alpha(theme.palette.primary.main, .16)}, 0px 1px 5px 0px ${alpha(theme.palette.primary.main, .76)}`,
		},
		inputCheckboxIcon_label: {
			fontSize: '1rem',
			padding: '5px',
			width: '100%',
			display: 'flex',
			flexDirection: 'column',
			justifyContent: 'center',
			borderRadius: `0px ${theme.shape.borderRadius}px ${theme.shape.borderRadius}px 0px`,
		},
		inputCheckboxIcon_labelUnselect: {
			color: darken(theme.palette.grey[500], .15),
			borderRight: `solid 2px ${darken(theme.palette.grey[500], .15)}`,
			borderTop: `solid 2px ${darken(theme.palette.grey[500], .15)}`,
			borderBottom: `solid 2px ${darken(theme.palette.grey[500], .15)}`,
		},
		inputCheckboxIcon_labelSelect: {
			color: theme.palette.primary.main,
			borderRight: `solid 2px ${theme.palette.primary.main}`,
			borderTop: `solid 2px ${theme.palette.primary.main}`,
			borderBottom: `solid 2px ${theme.palette.primary.main}`,
		},
		inputCheckboxIcon_labelDisable: {
			color: theme.palette.grey[300],
			borderRight: `solid 2px ${theme.palette.grey[300]}`,
			borderTop: `solid 2px ${theme.palette.grey[300]}`,
			borderBottom: `solid 2px ${theme.palette.grey[300]}`,
		},
		inputCheckboxIcon_labelSelectDisable: {
			color: theme.palette.primary[300],
			borderRight: `solid 2px ${theme.palette.primary[300]}`,
			borderTop: `solid 2px ${theme.palette.primary[300]}`,
			borderBottom: `solid 2px ${theme.palette.primary[300]}`,
		},
		inputCheckboxIcon_rippleChild: {
			backgroundColor: theme.palette.primary.main,
		},
		inputCheckboxIcon_rippleVisible: {
			opacity: 0.5,
			animation: `$ripple-enter ${theme.transitions.duration.standard}ms ${theme.transitions.easing.easeInOut}`
		},
		"@keyframes ripple-enter": {
			"0%": {
				transform: "scale(0)",
				opacity: 0.1
			},
			"100%": {
				transform: "scale(1)",
				opacity: 0.5
			}
		},
	});
});

export default useStyles;
